export default __webpack_public_path__ + "static/media/(Low Res) JD Reception-004_tn.4d03c90e.jpg";